export const filtersConfig = [
  {
    type: 'textInput',
    label: 'Location',
    placeholder: 'Type name of Location',
    key: 'locationName',
  },
  {
    type: 'textInput',
    label: 'Territory',
    placeholder: 'Type name of Territory',
    key: 'admLevel2',
  },
  {
    type: 'select',
    label: 'Measure Type',
    placeholder: 'Select Measure Type',
    key: 'typeOfMeasure',
    optionsName: 'riskMeasures',
  },
  {
    type: 'select',
    label: 'Responsibility',
    placeholder: 'Select Responsible Party',
    optionsName: 'responsibles',
    key: 'linkedStakeholderId',
  },
  {
    type: 'select',
    label: 'Proponent',
    placeholder: 'Select Proponent',
    key: 'sourceId',
    optionsName: 'sources',
  },
  {
    key: 'status',
    type: 'select',
    label: 'Dashboard::Select Status',
    placeholder: 'Dashboard::Select Status',
  },
  // {
  //   type: 'select',
  //   label: 'Dashboard::Risk Type',
  //   placeholder: 'Dashboard::Select risk type',
  //   key: 'riskType',
  // },
];

export const filtersData = {
  sources: [],
};
